<template>
    <div class="text-center">
        <v-btn width="26px" height="26px" class="mb-1" icon @click="deleteRow()">
                          <span class="icon-delete-21x21" style="font-size: 24px;">
                            <span class="path1 letterSpacing0" style="margin-right:-1px;" ></span>
                            <span class="path2"></span>
                          </span>
                        </v-btn>
        <v-btn width="26px" height="26px" class="mb-1" icon @click="ignoreBtnClick">
                          <span class="icon-ignore-21x21" style="font-size: 24px">
                            <span class="path1 letterSpacing0" style="margin-right:-1px;"></span>
                            <span class="path2"></span>
                          </span>
        </v-btn>
    </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  data: () => ({
  }),
  methods: {
      deleteRow() {
          this.params.context.componentParent.confirmationDialog(this.params.node.data)
      },
      ignoreBtnClick() {
          this.params.context.componentParent.ignoreBtnClick(this.params.node.data)
      }
  }
   
})
</script>